import { useNavigate, useSearchParams } from '@remix-run/react';
import { useLatest } from 'ahooks';
import { useEffect } from 'react';
import FilterBarNewBoardButton from '~/modules/design-board/component/all-pins/FilterBarNewBoardButton';
import GetStartedButton from '~/modules/design-board/component/all-pins/GetStartedButton';
import { useDesignBoardPageState } from '~/modules/design-board/component/context/DesignBoardContext';
import { useLoginModal } from '~/modules/design-board/hook/use-login-modal';
import { useUser, isUserLoggedIn } from '~/modules/user';

export const useGetStartedAction = (loggedInLink?: string) => {
    const user = useUser();
    const [searchParams] = useSearchParams();
    const isLoggedIn = isUserLoggedIn(user);
    const { dispatch } = useDesignBoardPageState();
    const { showLoginModal, loginModal } = useLoginModal({
        authSource: 'designBoard',
    });
    const navigate = useNavigate();

    const loggedInAction = () => {
        return loggedInLink
            ? navigate(loggedInLink)
            : dispatch({ type: 'OpenCreateNewDrawer' });
    };
    const onClickGetStarted = () => {
        return isLoggedIn ? loggedInAction() : showLoginModal();
    };

    const stableOnClickGetStarted = useLatest(onClickGetStarted);

    useEffect(() => {
        if (searchParams.get('createBoard')) {
            stableOnClickGetStarted.current();
        }
    }, [searchParams, stableOnClickGetStarted]);

    return {
        user,
        isLoggedIn,
        onClickGetStarted,
        newBoardButton: (
            <>
                <FilterBarNewBoardButton onClick={onClickGetStarted} />
                {!isLoggedIn && loginModal}
            </>
        ),
        getStartedButton: (
            <>
                <GetStartedButton onClick={onClickGetStarted} />
                {!isLoggedIn && loginModal}
            </>
        ),
    };
};
